/**
 * OC Chat Footer Component
 * Footer with optional disclaimer text
 * Only displays after user has sent their first message (not in initial state)
 */

import React from 'react';

import { FooterContainer, FooterText } from './OcChatFooter.styled';

export interface OcChatFooterProps {
  footerText?: string;
  askHumanButtonText?: string;
}

/**
 * OcChatFooter Component
 * Displays footer with optional text inside the input area
 * Shown after initial state (matching behavior of ReactRoot widget)
 */
export const OcChatFooter: React.FC<OcChatFooterProps> = ({
  footerText}) => {
  
  // Footer is now conditionally rendered by parent, so we don't need to check here
  if (!footerText) {
    return null;
  }

  return (
    <FooterContainer>
      <FooterText>{footerText}</FooterText>
    </FooterContainer>
  );
};

export default OcChatFooter;

